// import React from 'react'
import React, { useState, useEffect } from 'react'

import { Link, Route, Routes, useLocation } from 'react-router-dom'

import moment from 'moment'


// import { useNavigate } from "react-router"

import { Navbar, Container, Nav,  } from 'react-bootstrap'


import { PrivateRoute } from './PrivateRoute'

import NotFound from './pages/NotFound'
import Login from './pages/Login'
// import Users from './pages/Users'
// import Dashboard from './pages/Dashboard'
// import { ROLE } from './features/auth/auth'
import { ROLE } from './features/auth/role'

// import { useDispatch, useSelector } from 'react-redux'
// import { logout, selectCurrentUser, selectIsAuthenticated } from 'features/auth/authSlice'
import AuthService from './features/auth/auth.service'









import Calculadora from './pages/Calculadora'








// import MisInversiones from './pages/Inversion/MisInversiones'
import GestionInversiones from './pages/Inversion/GestionInversiones'
import AsesorInversiones from './pages/Inversion/AsesorInversiones'












//////////////////////// 
///// MODULOS
//////////////////////// 


import Usuarios from './pages/Usuarios/Usuarios'




import Departamentos from './pages/Departamentos/Departamentos'



import Tramites from './pages/Tramites/Tramites'
// import SeleccionTramites from './pages/Tramites/SeleccionTramites'


// import MesaAtencionCaptura from './pages/Tramites/MesaAtencionCaptura'


// import MiReporte from './pages/Reportes/MiReporte'
import MisTramites from './pages/Reportes/MisTramites'

import ReporteSucursal from './pages/Reportes/ReporteSucursal'
import ReporteProduccion from './pages/Reportes/ReporteProduccion'



// import Sucursales from './pages/Reportes/Sucursales'
import Sucursales from './pages/Sucursales/Sucursales'


import { default as AnaliticasSucursal } from './pages/Reportes/AnaliticasPorSucursal'
// import AnaliticasSucursal from './pages/Reportes/AnaliticasSucursal'


// import GestionSucursal from './pages/Sucursales/GestionSucursal'
import GestionUsuariosSucursal from './pages/Sucursales/GestionUsuariosSucursal'

import CiudadanosGestion from './pages/Ciudadanos/CiudadanosGestion'

import MesaAtencion from './pages/Mesa_Atencion/MesaAtencion'



import ReporteGerencial from './pages/Gerentes/ReporteGerencial'
import GerenciaAsesores from './pages/Gerentes/GerenciaAsesores'



import Estructura from './pages/Recursos_humanos/Estructura'

import RecursosHumanos from './pages/Recursos_humanos/RecursosHumanos'
import ReportesPersonal from './pages/Recursos_humanos/ReportesPersonal'
import FaltasRetardos from './pages/Recursos_humanos/FaltasRetardos'


import Aseguramiento from './pages/Aseguramiento/Aseguramiento'


import VerificacionTelefonica from './pages/Verificacion_Telefonica/Panel'
import VerificacionTramite from './pages/Verificacion_Telefonica/VerificacionTramite'


// import Solicitudes from './pages/Solicitudes/Solicitudes'
// // import Folios from './pages/Folios/Folios'
// import Folios from './pages/Folios/Folios'
// import Folio from './pages/Folios/Folio'


// import Autorizar from './pages/Folios/Autorizar'
// import TramitesAsistente from './pages/Asistentes/Tramites'
// import CapturaAsistente from './pages/Asistentes/CapturaAsistente'
// import SeleccionTramitesAsistente from './pages/Asistentes/SeleccionTramites'


import Contabilidad from './pages/Contabilidad/Contabilidad'




import Profile from './pages/Profile'




import RegistroUsuariosAsesores from './pages/RegistroUsuariosAsesores'


import DirectorComercial from './pages/DirectorComercial/DirectorComercial'







import Pagos from './pages/Pagos/Pagos'









import './App.scss';


function BootHeader() {
  // const dispatch = useDispatch()
  // const user = useSelector(selectCurrentUser)
  const user = AuthService.getCurrentUser()
  // const isAuthenticated = useSelector(selectIsAuthenticated)
  const isAuthenticated = AuthService.selectIsAuthenticated

 
    // let navigate = useNavigate();



let location = useLocation();
// console.log(location.pathname)

let activo_perfil = location.pathname === '/profile' ? 'active' : ''
let activo_pagos = location.pathname === '/pagos' ? 'active' : ''

let activo_tramites = location.pathname.indexOf('tramites/seleccion') > -1 ? 'active' : ''
let activo_mi_reporte = location.pathname === '/mi_reporte' ? 'active' : ''

let activo_reportes = location.pathname === '/sucursales' ? 'active' : ''
let activo_reporte_produccion = location.pathname === '/reporte_produccion' ? 'active' : ''

let activo_mesa = location.pathname === '/mesa' ? 'active' : ''
// let activo_mesa_captura = location.pathname === '/mesa/captura' ? 'active' : ''


let activo_gerencia = location.pathname.substr(0,17) === '/gerencia/reporte' ? 'active' : ''
let activo_gerencia_asesores = location.pathname === '/gerencia/asesores' ? 'active' : ''


let activo_recursos_humanos = location.pathname === '/recursos_humanos' ? 'active' : ''
let activo_reportes_rh = location.pathname === '/reportes_rh' ? 'active' : ''
let activo_estructura = location.pathname === '/estructura' ? 'active' : ''
let activo_faltas_retardos = location.pathname === '/faltas_retardos' ? 'active' : ''

let activo_departamentos = location.pathname === '/departamentos' ? 'active' : ''

let activo_aseguradora = location.pathname === '/aseguramiento' ? 'active' : ''
let activo_verificador_telefonico = location.pathname === '/verificaciones' ? 'active' : ''


let activo_director_comercial = location.pathname.indexOf('director_comercial') > -1 ? 'active' : ''


let activo_contabilidad = location.pathname.indexOf('contabilidad') > -1 ? 'active' : ''


let activo_calculadora = location.pathname.indexOf('calculadora') > -1 ? 'active' : ''





// let activo_inversiones = location.pathname.indexOf('inversiones') > -1 ? 'active' : ''
// let activo_mis_inversiones = location.pathname.indexOf('mis_inversiones') > -1 ? 'active' : ''
// let activo_inversiones_gestion = location.pathname.indexOf('inversiones/gestion') > -1 ? 'active' : ''


  const [ ROLE_NOMINA, setNomina ] = useState(false)
  const [ ROLE_PAGOS, setPagos ] = useState(false)

  const [ ROLE_ADMIN, setAdmin ] = useState(false)
  const [ ROLE_ADMIN_MESA, setAdminMesa ] = useState(false)
  const [ ROLE_ASESOR, setAsesor ] = useState(false)
  const [ ROLE_GERENTE, setGerente ] = useState(false)
  const [ ROLE_DEPARTAMENTO, setDepartamento ] = useState(false)
  const [ ROLE_RECURSOS_HUMANOS, setRecursos ] = useState(false)

  const [ ROLE_ASEGURADORA, setAseguradora ] = useState(false)
  const [ ROLE_VERIFICADOR_TELEFONICO, setVerificadorTelefonico ] = useState(false)
  // const [ ROLE_ANALISTA, setAnalista ] = useState(false)
  const [ ROLE_ASISTENTE, setAsistente ] = useState(false)
  const [ ROLE_DIRECTOR_COMERCIAL, setDirectorComercial ] = useState(false)

  const [ ROLE_CONTABILIDAD, setContabilidad ] = useState(false)

  const [ ROLE_CLIENTE, setCliente ] = useState(false)

  const [ ROLE_FINANZAS_CAPTURAS, setFinanzasCaptura ] = useState(false)

  useEffect(() => {

      if(user.rol === "ROLE_PAGOS") setPagos(true)
      if(user.rol === "ROLE_NOMINA") setNomina(true)


      if(user.rol === "ROLE_ADMIN") setAdmin(true)
      if(user.rol === "ROLE_ADMIN_MESA") setAdminMesa(true)


      if(user.rol === "ROLE_ASESOR_BASE") setAsesor(true)
      if(user.rol === "ROLE_ASESOR") setAsesor(true)


      if(user.rol === "ROLE_GERENTE") setGerente(true)
      if(user.rol === "ROLE_GERENTE_JR") setGerente(true)
      if(user.rol === "ROLE_GERENTE_CONSOLIDADO") setGerente(true)


      if(user.rol === "ROLE_DEPARTAMENTO") setDepartamento(true)
      if(user.rol === "ROLE_RECURSOS_HUMANOS") setRecursos(true)

      if(user.rol === "ROLE_ASEGURADORA") setAseguradora(true)
      if(user.rol === "ROLE_VERIFICADOR_TELEFONICO") setVerificadorTelefonico(true)

      if(user.rol === "ROLE_ASISTENTE") setAsistente(true)

      if(user.rol === "ROLE_DIRECTOR_COMERCIAL") setDirectorComercial(true)



      if(user.rol === "ROLE_CONTABILIDAD") setContabilidad(true)


      if(user.rol === "ROLE_CLIENTE") setCliente(true)
      if(user.rol === "ROLE_FINANZAS_CAPTURAS") setFinanzasCaptura(true)


  //         ASEGURADORA = "",
  // VERIFICADOR_TELEFONICO = "",

      // if(user.rol === "ROLE_ANALISTA") setAnalista(true)

  },[ 
      ROLE_ADMIN, 
      ROLE_ADMIN_MESA, 
      ROLE_NOMINA, 
      ROLE_PAGOS, 
      ROLE_ASESOR, 
      ROLE_DEPARTAMENTO, 
      ROLE_GERENTE, 
      ROLE_RECURSOS_HUMANOS, 
      ROLE_ASEGURADORA, 
      ROLE_VERIFICADOR_TELEFONICO , 
      ROLE_ASISTENTE , 
      ROLE_DIRECTOR_COMERCIAL , 
      ROLE_CONTABILIDAD , 
      ROLE_CLIENTE , 
      ROLE_FINANZAS_CAPTURAS,
      user
     ]);




  return (

    <>
    { isAuthenticated && ( 


        <React.Fragment>

          <Navbar bg="primary" expand="lg">
            <Container fluid>

              <Navbar.Brand >
                <img
                  src={ window.location.origin + '/assets/images/white.png'}
                  
                  height="30"
                  className="d-inline-block align-top"
                  alt="React Bootstrap logo"
                />
              </Navbar.Brand>


              <Navbar.Toggle aria-controls="navbarScroll" />
              <Navbar.Collapse id="navbarScroll">
                <Nav
                  className="me-auto my-2 my-lg-0"
                  style={{ maxHeight: '100px' }}
                  navbarScroll
                >
                  


                { (ROLE_ADMIN || ROLE_ADMIN_MESA || ROLE_NOMINA || ROLE_PAGOS || ROLE_ASESOR || ROLE_GERENTE || ROLE_DEPARTAMENTO || ROLE_RECURSOS_HUMANOS || ROLE_ASEGURADORA || ROLE_VERIFICADOR_TELEFONICO|| ROLE_ASISTENTE || ROLE_DIRECTOR_COMERCIAL|| ROLE_CONTABILIDAD || ROLE_FINANZAS_CAPTURAS) && (
                  <Link className={'nav-link ' + activo_perfil } to="/profile"> Perfil </Link>
                )}



                { (ROLE_ADMIN||ROLE_ADMIN_MESA) && (
                  <>
                      <Link className={'nav-link ' + activo_reportes } to="/sucursales"> Sucursales </Link>
                      <Link className={'nav-link ' + activo_reporte_produccion } to="/reporte_produccion"> Reporte Producción </Link>
                      <Link className={'nav-link ' + activo_departamentos } to="/departamentos"> Departamentos </Link>
                      <Link className={'nav-link ' + activo_calculadora } to="/calculadora"> Calculadora </Link>
                  </>
                )}





{
  // ROLE_PAGOS?'SI':'NO'
}


            { (ROLE_PAGOS) && (
              <>
                  <Link className={'nav-link ' + activo_pagos } to="/pagos"> Pagos </Link>
              </>
            )}






            { (ROLE_DEPARTAMENTO || ROLE_ADMIN_MESA) && (
              <>
                  <Link className={'nav-link ' + activo_mesa } to="/mesa"> Mesa de Control </Link>
              </>
            )}











            { ROLE_DIRECTOR_COMERCIAL && (
              <>
                <Link className={'nav-link ' + activo_reportes } to="/sucursales"> Sucursales </Link>
                <Link className={'nav-link ' + activo_director_comercial } to={'/director_comercial'}> Director Comercial </Link>
                <Link className={'nav-link ' + activo_reporte_produccion } to="/reporte_produccion"> Reporte Producción </Link>
                <Link className={'nav-link ' + activo_calculadora } to={'/calculadora'}> Calculadora </Link>  
                <Link className={'nav-link ' + activo_tramites } to="/tramites/seleccion"> Tramites </Link>
                <Link className={'nav-link ' + activo_mi_reporte } to="/mi_reporte"> Mi Reporte </Link>
              </>
            )}








            { ROLE_GERENTE && (
              <>
                  <Link className={'nav-link ' + activo_gerencia } to={'/gerencia/reporte/'+moment().format('YYYY')}> Reporte </Link>
                  <Link className={'nav-link ' + activo_gerencia_asesores } to={'/gerencia/asesores'}> Asesores </Link>
              </>
            )}













            { ROLE_RECURSOS_HUMANOS && (
              <>
                  <Link className={'nav-link ' + activo_recursos_humanos } to={'/recursos_humanos'}> Personal </Link>
                  <Link className={'nav-link ' + activo_estructura } to={'/estructura'}> Estructura </Link>
                  <Link className={'nav-link ' + activo_reportes_rh } to={'/reportes_rh'}> Reportes </Link>
                  <Link className={'nav-link ' + activo_faltas_retardos } to={'/faltas_retardos'}> Faltas  </Link>
              </>
            )}






            { ROLE_ASEGURADORA && (
              <>
                  <Link className={'nav-link ' + activo_aseguradora } to={'/aseguramiento'}> Aseguramiento </Link>
              </>
            )}











            { ROLE_VERIFICADOR_TELEFONICO && (
              <>
                  <Link className={'nav-link ' + activo_verificador_telefonico } to={'/verificaciones'}> Verificaciones </Link>
              </>
            )}












            { (ROLE_CONTABILIDAD || ROLE_ADMIN || ROLE_DIRECTOR_COMERCIAL || ROLE_FINANZAS_CAPTURAS) && (
              <>
                  <Link className={'nav-link ' + activo_contabilidad } to={'/contabilidad'}> Finanzas </Link>
              </>
            )}













            
            { 
            //   (ROLE_ASISTENTE) && (
            //     <Link className={'nav-link ' + activo_tramites_asistente } to="/asistente/captura"> Mi Captura </Link>
            // )
          }





            { 
              // (ROLE_ASESOR  ) && (
              //   <Link className={'nav-link ' + activo_inversiones } to="/inversiones"> Inversiones </Link>
              // )
            }

            { 
              // (ROLE_CLIENTE ) && (
              //   <Link className={'nav-link ' + activo_mis_inversiones } to="/mis_inversiones"> Mis Inversiones </Link>
              // )
            }

            { 
              // ( ROLE_ADMIN_MESA || ROLE_DEPARTAMENTO ) && (
              //   <Link className={'nav-link ' + activo_inversiones_gestion } to="/inversiones/gestion"> Inversiones </Link>
              // )
            }










            
            { 
              (ROLE_ASESOR || ROLE_GERENTE || ROLE_ASISTENTE || ROLE_ADMIN_MESA || ROLE_DEPARTAMENTO || ROLE_RECURSOS_HUMANOS ) && (
                <Link className={'nav-link ' + activo_tramites } to="/tramites/seleccion"> Tramites </Link>
            )
          }

            
            { 
              (ROLE_ASESOR || ROLE_GERENTE || ROLE_ASISTENTE || ROLE_ADMIN_MESA || ROLE_DEPARTAMENTO || ROLE_RECURSOS_HUMANOS ) && (
                <React.Fragment>
                  <Link className={'nav-link ' + activo_mi_reporte } to="/mi_reporte"> Mi Reporte </Link>
                  <Link className={'nav-link ' + activo_calculadora } to="/calculadora"> Calculadora </Link>
                </React.Fragment>
            )
          }




                </Nav>
              </Navbar.Collapse>

                <Navbar.Collapse className="justify-content-end">
                  <Navbar.Text>
                    <Link className="link" to="/profile"> {user?.nombres} </Link>
                  </Navbar.Text>
                </Navbar.Collapse>


            </Container>
          </Navbar>

        </React.Fragment>
        )
      }
      </>

  )



}

function App() {



  return (
    <>
      <BootHeader />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="*" element={<NotFound />} />

        


        <Route path="usuarios" element={<PrivateRoute roles={[ROLE.ADMIN]} component={Usuarios} />} />


        <Route path="departamentos" element={<PrivateRoute roles={[ROLE.ADMIN,ROLE.ADMIN_MESA]} component={Departamentos} />} />

        <Route path="sucursales" element={<PrivateRoute roles={[ROLE.ADMIN,ROLE.ADMIN_MESA,ROLE.ROLE_DIRECTOR_COMERCIAL,ROLE.DIRECTOR_COMERCIAL]} component={Sucursales} />} />
        <Route path="reporte_produccion" element={<PrivateRoute roles={[ROLE.ADMIN,ROLE.ADMIN_MESA,ROLE.ROLE_DIRECTOR_COMERCIAL,ROLE.DIRECTOR_COMERCIAL]} component={ReporteProduccion} />} />
        <Route path="sucursales/administracion/:uuid_sucursal" element={<PrivateRoute roles={[ROLE.ADMIN,ROLE.ADMIN_MESA]} component={GestionUsuariosSucursal} />} />
        <Route path="reporte_sucursal/:uuid_sucursal" element={<PrivateRoute roles={[ROLE.ADMIN,ROLE.ADMIN_MESA]} component={ReporteSucursal} />} />
        
        {
          // <Route path="analiticas_sucursal/:uuid_sucursal/:year" element={<PrivateRoute roles={[ROLE.ADMIN]} component={AnaliticasPorSucursal} />} />
        }

        <Route path="analiticas_sucursal/:uuid_sucursal/:year" element={<PrivateRoute roles={[ROLE.ADMIN,ROLE.ADMIN_MESA]} component={AnaliticasSucursal} />} />


        <Route path="mesa" element={<PrivateRoute roles={[ROLE.DEPARTAMENTO,ROLE.ADMIN_MESA]} component={MesaAtencion} />} />
        {
          // <Route path="mesa/captura" element={<PrivateRoute roles={[ROLE.DEPARTAMENTO]} component={MesaAtencionCaptura} />} />
        }


        <Route path="gerencia/reporte/:year" element={<PrivateRoute roles={[ROLE.GERENTE,ROLE.GERENTE_JR,ROLE.GERENTE_CONSOLIDADO]} component={ReporteGerencial} />} />
        <Route path="gerencia/asesores" element={<PrivateRoute roles={[ROLE.GERENTE,ROLE.GERENTE_JR,ROLE.GERENTE_CONSOLIDADO]} component={GerenciaAsesores} />} />




        <Route path="recursos_humanos" element={<PrivateRoute roles={[ROLE.RECURSOS_HUMANOS]} component={RecursosHumanos} />} />
        <Route path="reportes_rh" element={<PrivateRoute roles={[ROLE.RECURSOS_HUMANOS]} component={ReportesPersonal} />} />
        <Route path="estructura" element={<PrivateRoute roles={[ROLE.RECURSOS_HUMANOS]} component={Estructura} />} />
        <Route path="faltas_retardos" element={<PrivateRoute roles={[ROLE.RECURSOS_HUMANOS]} component={FaltasRetardos} />} />



        <Route path="aseguramiento" element={<PrivateRoute roles={[ROLE.ASEGURADORA]} component={Aseguramiento} />} />



        <Route path="verificaciones" element={<PrivateRoute roles={[ROLE.VERIFICADOR_TELEFONICO]} component={VerificacionTelefonica} />} />
        <Route path="verificacion/:uuid_tramite" element={<PrivateRoute roles={[ROLE.VERIFICADOR_TELEFONICO]} component={VerificacionTramite} />} />



        {
          ////////////////////////////// TRAMITE
        }

        <Route path="tramites/seleccion" element={<PrivateRoute roles={[ROLE.ASESOR, ROLE.ASESOR_BASE, ROLE.GERENTE, ROLE.GERENTE_JR,ROLE.GERENTE_CONSOLIDADO, ROLE.ASISTENTE, ROLE.ADMIN_MESA, ROLE.DEPARTAMENTO, ROLE.RECURSOS_HUMANOS,ROLE.ROLE_DIRECTOR_COMERCIAL,ROLE.DIRECTOR_COMERCIAL]} component={Tramites} />} />
{
        // <Route path="tramites/seleccion" element={<PrivateRoute roles={[ROLE.ASESOR, ROLE.GERENTE]} component={SeleccionTramites} />}>
        //   <Route path="tramite/:uuid_departamento" element={<PrivateRoute roles={[ROLE.ASESOR, ROLE.GERENTE]} component={Tramites} />} />
        // </Route>
}

{

        
        // <Route path="asistente/captura" element={<PrivateRoute roles={[ROLE.ASISTENTE]} component={CapturaAsistente} />} />
        
      }



        
        {
          // <Route path="mi_reporte" element={<PrivateRoute roles={[ROLE.ASESOR, ROLE.ASESOR_BASE, ROLE.GERENTE, ROLE.GERENTE_JR, ROLE.GERENTE_CONSOLIDADO, ROLE.ASISTENTE]} component={MiReporte} />} />
        }

        <Route path="mi_reporte" element={<PrivateRoute roles={[ROLE.ASESOR, ROLE.ASESOR_BASE, ROLE.GERENTE, ROLE.GERENTE_JR, ROLE.GERENTE_CONSOLIDADO, ROLE.ASISTENTE, ROLE.ADMIN_MESA, ROLE.DEPARTAMENTO, ROLE.RECURSOS_HUMANOS,ROLE.ROLE_DIRECTOR_COMERCIAL,ROLE.DIRECTOR_COMERCIAL]} component={MisTramites} />} />





        <Route path="profile" element={<PrivateRoute roles={[  
                                                          ROLE.ADMIN, 
                                                          ROLE.ADMIN_MESA, 
                                                          ROLE.NOMINA, 
                                                          ROLE.PAGOS, 
                                                          ROLE.ASESOR, 
                                                          ROLE.ASESOR_BASE,
                                                          ROLE.GERENTE, 
                                                          ROLE.GERENTE_JR, 
                                                          ROLE.GERENTE_CONSOLIDADO,
                                                          ROLE.DEPARTAMENTO, 
                                                          ROLE.RECURSOS_HUMANOS, 
                                                          ROLE.VERIFICADOR_TELEFONICO, 
                                                          ROLE.ASEGURADORA, 
                                                          ROLE.ASISTENTE,
                                                          ROLE.DIRECTOR_COMERCIAL,
                                                          ROLE.ROLE_CONTABILIDAD,
                                                          ROLE.ROLE_DIRECTOR_COMERCIAL,
                                                          ROLE.ROLE_FINANZAS_CAPTURAS,
                                                          ]} component={Profile} />} />



        <Route path="director_comercial" element={<PrivateRoute roles={[ROLE.DIRECTOR_COMERCIAL]} component={DirectorComercial} />} />


        <Route path="pagos" element={<PrivateRoute roles={[ROLE.PAGOS]} component={Pagos} />} />









        <Route path="contabilidad" element={<PrivateRoute roles={[ROLE.ADMIN, ROLE.ROLE_CONTABILIDAD, ROLE.ROLE_DIRECTOR_COMERCIAL, ROLE.ROLE_FINANZAS_CAPTURAS]} component={Contabilidad} />} />





        <Route path="inversiones" element={<PrivateRoute roles={[ROLE.ASESOR, ROLE.ASESOR_BASE]} component={AsesorInversiones} />} />



        <Route path="inversiones/gestion" element={<PrivateRoute roles={[ROLE.ADMIN_MESA,ROLE.DEPARTAMENTO]} component={GestionInversiones} />} />



        <Route path="ciudadanos" element={<PrivateRoute roles={[ROLE.ADMIN_MESA,ROLE.DEPARTAMENTO, ROLE.ASESOR, ROLE.ASESOR_BASE, ROLE.ASISTENTE]} component={CiudadanosGestion} />} />








        <Route path="calculadora" element={<PrivateRoute roles={[
                                                          ROLE.ADMIN, 
                                                          ROLE.ADMIN_MESA, 
                                                          ROLE.NOMINA, 
                                                          ROLE.PAGOS, 
                                                          ROLE.ASESOR, 
                                                          ROLE.ASESOR_BASE,
                                                          ROLE.GERENTE, 
                                                          ROLE.GERENTE_JR, 
                                                          ROLE.GERENTE_CONSOLIDADO,
                                                          ROLE.DEPARTAMENTO, 
                                                          ROLE.RECURSOS_HUMANOS, 
                                                          ROLE.VERIFICADOR_TELEFONICO, 
                                                          ROLE.ASEGURADORA, 
                                                          ROLE.ASISTENTE,
                                                          ROLE.ROLE_DIRECTOR_COMERCIAL,
                                                          ROLE.DIRECTOR_COMERCIAL,
                                                          ROLE.ROLE_CONTABILIDAD,
          ]} component={Calculadora} />} />






        <Route path="registro" element={<RegistroUsuariosAsesores />} />

        


      </Routes>



    </>
  )
}

export default App
